import { locales } from './locales';
import { defaultStore, LANGUAGES } from '../utils/config';
import { getContur } from '../utils/getContur';
import { getLanguage } from '../utils/getLanguage';
import { getEnvironmentByHostname } from '../utils/getEnvironmentByHostname';

export const defaultEnvironment = getEnvironmentByHostname();
export const defaultLanguage = getLanguage();
export const defaultContur = getContur();

/**
 * Возвращает словарь переводов для выбранного языка с учетом текущей страны (COUNTRY).
 * Формирует ключ в виде "<language>-<COUNTRY>" и возвращает соответствующий словарь из locales.
 *
 * Пример: при language="ru" и COUNTRY="KZ" вернет merge({}, ru.json, ru-KZ.json)
 *
 * @param {string} [language=languages.ru] - код языка, "ru" / "kz" / "ar" / "en".
 * @returns {object} Объект словаря переводов для языка/страны.
 */
export const buildLocaleForCountry = (language = LANGUAGES.ru) => {
  const country = defaultStore.toUpperCase();

  const localeAndCountry = `${language}-${country}`;

  if (!language || !country) {
    return locales['ru-RU'];
  }

  return locales[localeAndCountry];
};

/**
 * Проверяет сохраненный язык в localStorage перед инициализацией
 * @returns {string} - сохраненный язык.
 */
export const getInitialLanguage = () => {
  try {
    const savedLang = localStorage.getItem('lang');

    if (savedLang && LANGUAGES[savedLang]) {
      return savedLang;
    }
  } catch (e) {
    console.warn('Не удалось прочитать язык из localStorage:', e);
  }
  return defaultLanguage;
};

/**
 * Преобразует внутренний язык в формат для внешних систем (Plaid API)
 * @param {string} language - язык (ru, kz, en, ar)
 * @returns {string} - код языка в нужном формате для апи
 */
export const getPlaidLanguageId = (language) => {
  switch (language) {
    case LANGUAGES.ar:
      return LANGUAGES.ar;
    case LANGUAGES.en:
      return LANGUAGES.en;
    case LANGUAGES.kz:
      return 'ru_KZ';
    default:
      return 'ru_RU';
  }
};
